import {
  selectorFamily,
  selector,
  atom
} from 'recoil';
import * as vodaLend from '../api/vodaLend';

const fetchState = async (queryParams) => {
  const response = await vodaLend.getProductList(queryParams);
  return response;
};

const fetchProductListByBusinessId = async (businessId) => {
  const response = await vodaLend.getProductsByBusinessId(businessId);
  return response;
};

export const productListFetch = selectorFamily({
  key: 'productListFetch',
  get: (queryParams) => async () => await fetchState(queryParams)
});

export const productListFetchByBusinessId = selectorFamily({
  key: 'productListFetchByBusinessId',
  get: (businessId) => async () => await fetchProductListByBusinessId(businessId)
});

export const pageTitle = atom({
  key: 'pageTitle',
  default: ''
});

export const pageTitleSubmit = selector({
  key: 'pageTitleSubmit',
  get: async ({ get }) => await get(pageTitle),
  set: ({ set }, inputData) => {
    set(pageTitle, inputData?.pageTitle);
  }
});